// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__73tz-","obliqueLineWrap":"membershipbadge_obliqueLineWrap__XDcqt","obliqueLine":"membershipbadge_obliqueLine__38s_p"};